import React from "react";
import Firebase from "../../constants/Firebase";
// import "./form.css";

class addLabelForm extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			title: "",
			editCat: "",
			correctLength: true,
		};
		this.input = React.createRef();
		this.handleChangeLabel = this.handleChangeLabel.bind(this);
		this.handleChangeEditCat = this.handleChangeEditCat.bind(this);
		this.submitLabel = this.submitLabel.bind(this);
		this.submitEditCat = this.submitEditCat.bind(this);
		this.postLabelFirebase = this.postLabelFirebase.bind(this);
		this.postEditCatFirebase = this.postEditCatFirebase.bind(this);
		this.deleteCategory = this.deleteCategory.bind(this);
	}

	// FOCUS IN MODAL
	componentDidMount() {
		this.input.focus();
	}

	// LABEL SET STATE && UPPERCASE
	handleChangeLabel(event) {
		this.setState({ title: event.target.value.toUpperCase() });
	}

	// EDIT CATEGORY SET STATE && UPPERCASE
	handleChangeEditCat(event) {
		this.setState({ editCat: event.target.value.toUpperCase() });
	}

	// SUBMIT LABEL
	submitLabel(e) {
		e.preventDefault();

		// CORRECT LENGTH CHECK
		if (this.state.title.length >= 1 && this.state.title.length <= 25) {
			// POST TO FIREBASE FUNCTION
			this.postLabelFirebase();
		} else {
			// CORRECT LENGTH MESSAGE APPEARS
			this.setState({
				correctLength: false,
			});
		}
	}

	// POST LABEL TO FIREBASE
	async postLabelFirebase() {
		const requestOptions = {
			method: "POST",
			redirect: "follow",
			headers: {
				"Content-Type": "application/json",
			},
			// CONVERT STATE IN JSON STRING
			body: JSON.stringify({
				title: this.state.title,
			}),
		};

		await fetch(
			`${Firebase.databaseURL}/users/${this.props.user.localId}/tabs/${this.props.tabID}/categories/${this.props.catID}/labels.json?auth=${this.props.user.idToken}`,
			requestOptions
		)
			// .then((response) => response.json())
			.then((result) => {
				// CLOSE MODAL AFTER POST
				this.props.closeModal();
			})
			.catch((error) => console.log("error:", error));

		// FETCH AFTER POST TO REFRESH CONTENT
		this.props.fetchFirebase();
	}

	// SUBMIT EDIT CAT
	submitEditCat(e) {
		e.preventDefault();

		// CORRECT LENGTH CHECK
		if (this.state.editCat.length >= 1 && this.state.editCat.length <= 25) {
			// POST TO FIREBASE FUNCTION
			this.postEditCatFirebase();
		} else {
			// CORRECT LENGTH MESSAGE APPEARS
			this.setState({
				correctLength: false,
			});
		}
	}

	// POST EDIT CAT TO FIREBASE
	async postEditCatFirebase() {
		const requestOptions = {
			method: "PATCH",
			redirect: "follow",
			headers: {
				"Content-Type": "application/json",
			},
			// CONVERT STATE IN JSON STRING
			body: JSON.stringify({
				title: this.state.editCat,
			}),
		};

		await fetch(
			`${Firebase.databaseURL}/users/${this.props.user.localId}/tabs/${this.props.tabID}/categories/${this.props.catID}.json?auth=${this.props.user.idToken}`,
			requestOptions
		)
			// .then((response) => response.json())
			.then((result) => {
				// CLOSE MODAL AFTER POST
				this.props.closeModal();
			})
			.catch((error) => console.log("error:", error));

		// FETCH AFTER POST TO REFRESH CONTENT
		this.props.fetchFirebase();
	}

	// FETCH DELETE CATEGORY
	async deleteCategory() {
		const requestOptions = {
			method: "DELETE",
			redirect: "follow",
		};

		await fetch(
			`${Firebase.databaseURL}/users/${this.props.user.localId}/tabs/${this.props.tabID}/categories/${this.props.catID}.json?auth=${this.props.user.idToken}`,
			requestOptions
		)
			// PARSE JSON HTTP RESPONSE TO TRANSFORM INTO JS OBJECT
			.then((response) => response.json())
			.then((result) => {
				// console.log(result);
			})
			.catch((error) => console.log("error:", error));
		// FETCH AFTER DELETE TO REFRESH CONTENT
		this.props.fetchFirebase();
	}

	render() {
		return (
			<div className="form-wrapper-margin">
				<div className="form-outer-wrapper">
					<legend className="form-legend">Add Label to</legend>
					<form className="form-div" action="#">
						{/* LABEL INPUT */}
						<input
							required
							className="form-input-tab"
							type="text"
							name="label-title"
							id="label-title"
							placeholder={this.props.catTitle}
							value={this.state.editCat}
							onChange={this.handleChangeEditCat}
						/>

						{/* SUBMIT BUTTON */}
						<button className="edit-button" onClick={this.submitEditCat}>
							Edit
						</button>
					</form>

					{/* DELETE CATEGORY BUTTON*/}
					<button
						className="delete-tab-button"
						onClick={(e) => {
							if (window.confirm("Are you sure you wish to delete this item?"))
								this.deleteCategory(e);
						}}
					>
						Delete
					</button>
				</div>
				<form className="form-div-column" action="#">
					{/* LABEL FORM LEGEND */}

					{/*LABEL LABEL */}
					<label className="form-label" htmlFor="label-title">
						Label name
					</label>

					{/* LABEL INPUT */}
					<input
						required
						className="form-input"
						type="text"
						name="label-title"
						id="label-title"
						// placeholder="LABEL 1"
						value={this.state.title}
						onChange={this.handleChangeLabel}
						ref={(inputFocus) => {
							this.input = inputFocus;
						}}
					/>

					{/*  CORRECT LENGTH CHECK MESSAGE */}
					{this.state.correctLength ? null : (
						<p className="p-correct-length">
							Label length can be between 1 and 25 characters.
						</p>
					)}

					{/* SUBMIT BUTTON */}
					<button className="submit-button" onClick={this.submitLabel}>
						Add Label
					</button>
				</form>
			</div>
		);
	}
}

export default addLabelForm;
